import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const CustomRadioButton = ({ 
  label, 
  checked, 
  onChange, 
  name, 
  containerClass='', 
  ...props 
}) => {
  return (
    <div className={`custom-radio-button ${containerClass}`}>
      <Form.Check
        type={'radio'}
        label={label}
        checked={checked}
        onChange={onChange}
        name={name}
        {...props}
      />
    </div>
  );
};

CustomRadioButton.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  containerClass: PropTypes.string
};

export default CustomRadioButton;